import { Audio, AudioCreate,  AudioCreateOrUpdate, MODES } from '../types/audio';
import { apiClient } from './sutras';

export const getAudios = async (
  projectName: string,
  section: string,
  chapter: number,
  number: number,
  mode?: string,
): Promise<Audio[]> => {
  if (!projectName) {
    throw new Error('Project name is required');
  }
    // If no specific mode is requested, fetch all languages
  if (!mode) {
    const allAudios: Audio[] = [];
    var aud: Audio;
    for (const mode of Object.values(MODES)) {
      try {
        const url = `/sutras/${projectName}/${section}/${chapter}/${number}/audio?mode=${mode}`;
        console.log('Fetching audios for mode:', mode, 'URL:', url);
        const response = await apiClient.get(url);
        if (response.data) {
          aud = {} as Audio; aud.file_path = response.data; aud.mode = mode;
          allAudios.push(aud);
        }
      } catch (err) {
        // Ignore 404 errors for specific mode
        if (!(err instanceof Error && err.message.includes('404'))) {
          console.error(`Error fetching audios for mode ${mode}:`, err);
        }
      }
    }
    return allAudios;
  }
  
  const url = `/sutras/${projectName}/${section}/${chapter}/${number}/audio?mode=${mode}`;
  console.log('GET Audios URL:', url);
  const response = await apiClient.get(url);
  
  // Handle both single object and array responses
  const data = response.data;
  if (Array.isArray(data)) {
    data.forEach(element => {
      element.mode = mode;
    });
    return data;
  } else if (data && typeof data === 'object') {
    data.mode = mode;
    return [data];
  } else {
    console.warn('Unexpected response format:', data);
    return [];
  }
};

export async function createAudio(
  project: string,
  section: string,
  chapter: number,
  number: number,
  audio:  AudioCreateOrUpdate
) {
  if (!audio.file_path) {
    throw new Error("No file selected");
  }

  const formData = new FormData();
  formData.append('file', audio.file_path);
  formData.append('section', section);
  let url = `/sutras/${project}/${section}/${chapter}/${number}/audio?mode=${audio.mode}`;
  const response = await apiClient.post(url,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  console.log('CREATE Audio URL:', url, 'formData:', formData, ' Audio file path:', audio.file_path);
  return response.data.audio;
}

export async function updateAudio(
  project: string,
  section: string,
  chapter: number,
  number: number,
  audio:  AudioCreateOrUpdate
) {
  if (!audio.file_path) {
    throw new Error("No file selected for update");
  }

  const formData = new FormData();
  formData.append('file', audio.file_path); // Assuming it's still a File type
  formData.append('section', section);
  const mode = audio.mode;
  let url = `/sutras/${project}/${section}/${chapter}/${number}/audio?mode=${mode}`
  const response = await apiClient.put(url,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  console.log('UPDATE Audio URL:', url);
  console.log('UPDATE Audio Data:', audio);
  return response.data;
}

export async function deleteAudio(
  project: string,
  section: string,
  chapter: number,
  number: number,
  mode: string
) {
  let url = `/sutras/${project}/${section}/${chapter}/${number}/audio?mode=${mode}`;
  const response = await apiClient.delete(
    url,
  );
  console.log('DELETE Audio URL:', url);
  return response.data;
}
